module.exports = __webpack_public_path__ + "assets/balloon1.svg";